import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourConsentsApi from '@/features/dashboard/tourConsents/api/tourConsentsApi.ts';
import { toast } from 'sonner';
import { tourConsentsApiQueryKeys } from '@/features/dashboard/tourConsents/api/tourConsentsApi.queryKeys.ts';
import { UpdateTourConsentDto } from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';

export default function useEditTourConsent(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: UpdateTourConsentDto) =>
      tourConsentsApi.edit(dto.id, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourConsentsApiQueryKeys.byTourId(tourId),
      });
      toast.success('Zgoda została zaktualizowana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas aktualizacji zgody.',
      });
    },
  });
}
